import React, { useEffect, useState } from 'react'
import Sidebar from '../components/Sidebar'
import Header from '../components/Header'
import ContentListTable from '../components/Content/ContentListTable'
import ContentDeleteModal from '../components/Content/ContentDeleteModal'

const ContentListPage = () => {
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [currentId, setCurrentId] = useState('');

  useEffect(() => {
    document.title = 'Konten - Admin Hi Nano';
  });

  const clickDelete = (id) => {
    setCurrentId(id);
    setShowDeleteModal(true);
  }

  const closeDelete = () => {
    setShowDeleteModal(false);
  }

  return (
    <div className="flex min-h-screen bg-slate-100">
      <Sidebar />
      <div className="flex-1 p-10 ml-28">
        <Header title="Konten" />
        <ContentListTable clickDelete={clickDelete} />
      </div>
      {
        showDeleteModal ? (
          <ContentDeleteModal closeDelete={closeDelete} id={currentId}/>
        ) : ("")
      }
    </div>
  )
}

export default ContentListPage